import useApiWorker from 'hooks/useApiWorker';
import { Execution, ExecutionSummary, RuleDetails } from '../types/execution';

export async function GetExecutions(queryParams?: string): Promise<ApiListResponse<Execution>> {
  const apiWorker = useApiWorker();
  if (!queryParams) queryParams = '';
  const path = `/executions?` + queryParams;
  return apiWorker
    .get<Array<Execution>>(path)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      if (error.response.status == 403) {
        return {
          success: false,
          message: 'You do not have permission to view job data for that district/school.',
        };
      }
      if (error.response.status == 404) {
        return {
          success: false,
          message: 'Failed to find job data for district/school.',
        };
      }
      return {
        success: false,
        message: error.response.data,
      };
    });
}

export async function GetExecutionSummary(jobName?: string, logId?: string): Promise<ApiResponse<ExecutionSummary>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .get<ExecutionSummary>(`/executions/${jobName}/${logId}`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}

export async function GetExecutionRuleDetails(jobName?: string, logId?: string, ruleName?: string): Promise<ApiResponse<RuleDetails>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .get<RuleDetails>(`/executions/${jobName}/${logId}/${ruleName}`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}

export async function RunJob(jobName?: string, queryParams?: string): Promise<ApiResponse<string>> {
  const apiWorker = useApiWorker();
  if (!queryParams) queryParams = '';
  const path = `/executions/${jobName}/execute?` + queryParams;
  return apiWorker
    .put<string>(path)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}

export async function RunJobForAllSchoolsInDistrict(jobName?: string): Promise<ApiResponse<string>> {
  const apiWorker = useApiWorker();
  const path = `/executions/${jobName}/execute-district`;
  return apiWorker
    .put<string>(path)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}

export async function ExportExecutionRuleDetails(jobName?: string, logId?: string, ruleName?: string): Promise<ApiResponse<BlobPart>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .get(`/executions/${jobName}/${logId}/${ruleName}/export`, {
      responseType: 'blob',
    })
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}

export async function ExportJobExecutionDetails(jobName?: string, logId?: string): Promise<ApiResponse<BlobPart>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .get(`/executions/${jobName}/${logId}/export`, {
      responseType: 'blob',
    })
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}
